import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRepeatedIp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M1.75 3.783a1.1 1.1 0 0 1 1.1-1.1H4.5a.55.55 0 1 1 0 1.1H2.85V16.24H4.5a.55.55 0 0 1 0 1.1H2.85a1.1 1.1 0 0 1-1.1-1.1zm15.4-1.1a1.1 1.1 0 0 1 1.1 1.1V16.24a1.1 1.1 0 0 1-1.1 1.1H15.5a.55.55 0 1 1 0-1.1h1.65V3.783H15.5a.55.55 0 1 1 0-1.1z" />
    <path
      fillRule="evenodd"
      d="M6.03 9.287c0-2.397 1.866-3.95 3.97-3.95s3.97 1.553 3.97 3.95c0 .706-.276 1.532-.913 2.493-.635.959-1.607 2.016-2.937 3.17a.18.18 0 0 1-.24 0c-1.33-1.154-2.302-2.211-2.937-3.17-.637-.96-.912-1.787-.912-2.493ZM10 4.067c-2.731 0-5.24 2.048-5.24 5.22 0 1.039.403 2.108 1.123 3.195.721 1.088 1.784 2.23 3.164 3.428a1.45 1.45 0 0 0 1.906 0c1.38-1.198 2.443-2.34 3.164-3.428.72-1.087 1.123-2.156 1.123-3.195 0-3.172-2.509-5.22-5.24-5.22m-1.24 7.586a.1.1 0 0 1-.1.1h-.58a.1.1 0 0 1-.1-.1V7.54a.1.1 0 0 1 .1-.1h.581a.1.1 0 0 1 .1.1zm.847-4.114a.1.1 0 0 1 .1-.1h1.518q.497 0 .834.185.34.186.512.51.175.323.175.733 0 .415-.175.738a1.25 1.25 0 0 1-.516.507q-.342.184-.841.184h-.726a.1.1 0 0 0-.1.1v1.257a.1.1 0 0 1-.1.1h-.581a.1.1 0 0 1-.1-.1V7.54Zm.881 2.114a.1.1 0 0 1-.1-.1V8.192a.1.1 0 0 1 .1-.1h.616q.293 0 .479.099a.6.6 0 0 1 .276.272q.09.174.09.404a.9.9 0 0 1-.09.407.64.64 0 0 1-.274.278 1 1 0 0 1-.476.101z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRepeatedIp;
